import View from './View'

const Container = (rebateData) => {
  return <View title="Single Rebate" data={rebateData} />
}

export default Container
